import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { Navigate, useParams } from "react-router-dom";

import { ScoutConversationViewer } from "./ScoutConversationViewer";

// Routing wrapper for /staff/observe/scout-conversation/:conversationId.
// Keeps the viewer component itself free of router concerns so the same
// component renders cleanly in tests and (later) in a sub-tab without
// duplicating useParams plumbing.
export function ScoutConversationViewerRoute() {
  const { conversationId } = useParams();
  // Two crumbs: an "Observe" link out (and a `?tab=scout-conversations`
  // link back to the list) plus the leaf "Scout Conversation" label. The
  // viewer is a full-viewport route outside the Observe tab chrome, so
  // these crumbs are the only way to navigate back without using the
  // browser's back button.
  useBreadcrumb([
    { label: "Observe", to: "/staff/observe" },
    { label: "Scout Conversations", to: "/staff/observe?tab=scout-conversations" },
    { label: "Scout Conversation" },
  ]);

  if (!conversationId) {
    // Router should have matched the dynamic segment for us to be here, so
    // this guard is mostly to satisfy the type system. If a stray link drops
    // the id, bounce back to the conversations tab rather than rendering a
    // broken viewer.
    return <Navigate to="/staff/observe?tab=scout-conversations" replace />;
  }

  return <ScoutConversationViewer conversationId={conversationId} />;
}
